import { dispatch } from '../redux/store';

export function errorHandler(data, handleNext, hasError){
    if (!data || typeof data !== 'object') {
        const fallback = typeof data === 'string' ? data : 'Something went wrong';
        if (typeof handleNext === 'function') handleNext({ message: fallback, success: false });
        if (hasError) dispatch(hasError(fallback));
        return;
    }
    let message = '';
    Object.entries(data).forEach(([key, value], index) => {
        if(typeof value === 'object'){
            Object.entries(value).forEach(([, innerValue]) => {
                message = `${message + (index === 0 ? '' : ', ')  }${key}: ${innerValue}`; // Get second parameters
            });
        }
        if(typeof value === 'string'){
            message = `${message + (index === 0 ? '' : ', ')  }${key}: ${value}`;
        }
    });
    if(typeof handleNext === 'function') {
        handleNext({
            message,
            success: false
        });
    }
    if(hasError){
        dispatch(hasError(message));
    }
}